import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  prepareHeaders: (headers, { getState }) => {
    const businessId = localStorage.getItem('businessId');
    headers.set('Content-Type', 'application/json');
    headers.set('Accept', 'application/json');


    if (businessId) {
      headers.set("business", businessId);
    }
    
    return headers;
  },
});
